import { App } from 'antd';
import { useEffect } from 'react';
import { setNotificationApi, setMessageApi } from '@/uicomponents';

/**
 * Binds the antd App context notification and message APIs so that
 * showNotification() and message.success/info/etc. work correctly within the theme.
 */
export const NotificationBinder = () => {
  const { notification, message } = App.useApp();

  useEffect(() => {
    setNotificationApi(notification);
    setMessageApi(message);
  }, [notification, message]);

  return null;
};
